// extracted by mini-css-extract-plugin
module.exports = {"panel-layout":"panel_panel__2Wr8C","dark-gray":"#111","default":"_typography_default__1dNnZ","form":"IntroForm_form__pKKId _typography_default__1dNnZ panel_panel__2Wr8C"};